import * as React from 'react';
import { Button, ModalWindow } from '@cian/ui-kit';

interface IConfirmModalProps {
  onClose(): void;
  onConfirm(): void;
  isOpen: boolean;
  headText: string;
  confirmText: string;
  dismissText: string;
}

const ConfirmModal = (props: IConfirmModalProps) => (
  <ModalWindow
    open={props.isOpen}
    width={500}
    onClose={props.onClose}
    title={props.headText}
    footer={
      <>
        <Button data-name="ModalConfirmButton" size="XS" theme="fill_primary" onClick={props.onConfirm}>
          {props.confirmText}
        </Button>
        <Button data-name="ModalCancelButton" size="XS" theme="fill_white_primary" onClick={props.onClose}>
          {props.dismissText}
        </Button>
      </>
    }
  />
);

export { ConfirmModal };
